// Template pesan disimpan sebagai SELISIH dari bawaan (bukan salinan ke-18-nya sekaligus).
// Sebab: kalau seluruh isi ikut tersimpan, mengedit satu pesan membekukan 17 pesan lain pada
// teks bawaan saat itu — perbaikan teks bawaan berikutnya tak akan pernah terlihat di toko.
type Kamus = Record<string, string>;

const sama = (a: string, b: string): boolean => a.trim() === b.trim();

/**
 * Hasil simpanan baru setelah satu kunci diubah; kunci yang isinya = bawaan dibuang.
 * Sekalian membersihkan kunci LAIN yang isinya sudah sama dengan bawaan — ini yang menyembuhkan
 * baris lama yang terlanjur menyimpan salinan penuh, tanpa perlu migrasi khusus.
 */
export function simpanSelisih(tersimpan: Kamus, bawaan: Kamus, kunci: string, isi: string): Kamus {
  const out: Kamus = {};
  for (const [k, v] of Object.entries(tersimpan)) if (!sama(v, bawaan[k] ?? '')) out[k] = v;
  if (sama(isi, bawaan[kunci] ?? '')) delete out[kunci];
  else out[kunci] = isi;
  return out;
}

/** Apakah kunci ini sudah diubah dari teks bawaan. */
export const berbedaDariBawaan = (tersimpan: Kamus, bawaan: Kamus, kunci: string): boolean =>
  kunci in tersimpan && !sama(tersimpan[kunci] ?? '', bawaan[kunci] ?? '');
